import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../button';
import Select from '../select'
// import { Button } from '../../../components/button';
import * as Svg from "../svg";
import { getAllowedExportFields, getExportPreview, createExport } from "../../slices/export";
import Table from "../table";
// import { SaveIndicator } from "../save-indicator";
import { ExportIndicator } from "../export-indicator";
import moment from 'moment';

const translations = [
    gettext('Export preview'),
    gettext("Export title"),
    gettext("Columns to export"),
    gettext("Choose data columns for export"),
    gettext('Export preview'),
    gettext('Request an export'),
    gettext("Select the columns you want to export to see a preview"),
    gettext("An error occurred while processing your request. Please contact support for further information."),
]


export const ExportModal = ({
    show,
    onClose,
    model,
    filters,
    onClick,
    children,
    defaultTitle,
}) => {
    const dispatch = useDispatch()
    const exportFields = useSelector((state) => state.export.exportFields)
    const exportPreview = useSelector((state) => state.export.exportPreview)
    const [title, setTitle] = useState(`${defaultTitle} ${moment().format('DD.MM.yyyy HH:mm')}`)
    const [selectedFields, setSelectedFields] = useState([])
    const [previewColumns, setPreviewColumns] = useState([])
    const [isGenerating, setIsGenerating] = useState(false)
    const [hasExportError, setHasExportError] = useState(false)
    const selectRef = useRef();

    useEffect(() => {
        dispatch(getAllowedExportFields({ 'type': model }))
    }, [])

    const generatePreview = () => {
        if (selectedFields.length > 0) {
            dispatch(getExportPreview({ 'type': model, 'fields': selectedFields, 'filters': filters }))
        } else {
            setPreviewColumns([])
        }
    }

    const selectOnChange = (data, options) => {
        if ((options.action === "clear") || (options.action === 'remove-value')) {
            setTimeout(() => selectRef.current.inputRef.blur(), 1);
        }
        setSelectedFields(data)
    }

    const updatePreview = () => {
        if (exportPreview.length > 0) {
            let columns = []
            selectedFields.forEach((field) => {
                let label = field.label
                columns.push({
                    Header: gettext(label),
                    accessor: field.value,
                })
            })
            setPreviewColumns(columns);
        }
    }

    const clearAndClose = () => {
        setSelectedFields([]);
        setPreviewColumns([]);
        setIsGenerating(false);
        setHasExportError(false)
        onClose();
    }

    useEffect(() => {
        updatePreview()
    }, [exportPreview])

    const generateExport = () => {
        setIsGenerating(true)
        dispatch(createExport({ 'export_type': model, 'export_fields': selectedFields, 'export_filters': filters, 'export_title': title }))
            .unwrap()
            .then((data) => { setIsGenerating(false); clearAndClose() })
            .catch((error) => { setHasExportError(true) })
    }

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-close" onClick={clearAndClose}><Svg.SvgClose></Svg.SvgClose></div>
                <div className="modal-icon"><Svg.SvgExport></Svg.SvgExport></div>
                <label>{gettext("Export title")}</label>
                <input className="form-control mb-3" type="text" placeholder={gettext("Export title")} value={title} onChange={(e) => setTitle(e.target.value)} />
                <label>{gettext("Columns to export")}</label>
                <Select
                    isMulti
                    name="columns"
                    placeholder={gettext("Choose data columns for export")}
                    options={exportFields}
                    ref={selectRef}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    getOptionLabel={(option) => `${gettext(option.label)}`}
                    closeMenuOnSelect={false}
                    onChange={(data, action) => selectOnChange(data, action)}
                    noOptionsMessage={() => null} // Close menu when all selected
                    onBlur={() => generatePreview()}
                />
                {previewColumns.length > 0 ?
                    <>
                        <p className="fw-bolder fs-4 text-start mt-4">{gettext('Export preview')}</p>
                        <div className="previewtable-wrapper">
                            <Table columns={previewColumns} data={exportPreview} size="sm" />
                        </div>
                    </>
                    :
                    <p className="fs-4 fw-bolder mt-4">{gettext("Select the columns you want to export to see a preview")}</p>
                }


                <div className="modal-buttons text-center">
                    { hasExportError ? 
                        <div>{ gettext("An error occurred while processing your request. Please contact support for further information.")}</div>
                    :
                        <>
                        {isGenerating ?
                            <ExportIndicator isProcessing={isGenerating} hasError={hasExportError} />
                            :
                            <Button variant="primary" size="sm" onClick={generateExport} disabled={selectedFields.length === 0}>{gettext('Request an export')}</Button>
                        }
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

